import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import Cookies from "js-cookie";

import { useApp } from "@context/AppProvider";
import Listing from "@components/product/list";
import styles from "@styles/listing.module.scss";
import SeoMeta from "@components/common/seo";
import { api } from "@utils/api";
const AgeValidatorModal = dynamic(() => import("@models/ageValidator.modal"));
import Loading from "@components/Loading";
import { ageVerified } from "@utils/functions";
function ProductList(props) {
  const router = useRouter();

  const {
    idb: { isoCode, showRegisterPop },
    setIdb,
  } = useApp();

  const [data, setData] = useState({
    isModalShow: false,
    listLoadProduct: false,
    is18Plus: null,
    isoCode: null,
    showRegisterPop: false,
  });

  const { slug, ...filters } = router.query;
  let brand = null,
    category = null;

  if (slug && slug.length === 1) {
    brand = slug[0];
  } else if (slug && slug.length === 2) {
    brand = slug[0];
    category = slug[1];
  } else {
    throw Error();
  }

  useEffect(() => {
    const init = () => {
      let obj = {};
      if (isoCode.toLowerCase() === "nz" && props.is18Plus) {
        obj = {
          isModalShow: true,
          listLoadProduct: true,
          is18Plus: props.is18Plus,
        };
      } else {
        obj = {
          isModalShow: false,
          listLoadProduct: true,
          is18Plus: props.is18Plus,
        };
      }
      setData((preState) => ({
        ...preState,
        ...obj,
      }));
    };

    if (isoCode && !data.listLoadProduct && !showRegisterPop) {
      init();
    }
  }, [isoCode, props.is18Plus, data.listLoadProduct, showRegisterPop]);

  useEffect(() => {
    if (data.is18Plus !== null && props.is18Plus !== data.is18Plus) {
      setData((preState) => ({
        ...preState,
        listLoadProduct: false,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.is18Plus, router.asPath]);

  useEffect(() => {
    if (
      isoCode !== null &&
      !Cookies.get("isoCode") &&
      isoCode.toLowerCase() !== data?.isoCode?.toLowerCase()
    ) {
      setData((preState) => ({
        ...preState,
        listLoadProduct: false,
        isoCode: isoCode,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isoCode]);

  useEffect(() => {
    if (showRegisterPop && isoCode) {
      let obj = {};
      if (isoCode.toLowerCase() === "nz" && !ageVerified()) {
        setTimeout(() => {
          setIdb((val) => ({ ...val, showRegisterPop: false }));
        }, 3000);
        obj = {
          showRegisterPop: true,
        };
      } else {
        obj = {
          isModalShow: false,
          listLoadProduct: true,
        };
      }
      setData((preState) => ({
        ...preState,
        ...obj,
      }));
    }
  }, [data.showRegisterPop, isoCode, setIdb, showRegisterPop]);

  if (!data.isModalShow && !data.listLoadProduct) {
    return <Loading />;
  }

  const title = props.brand ? props.brand.Name : `Favourite brand`;
  return (
    <div className={styles.listingPageBlock}>
      <SeoMeta
        title={`${title} | Shop Online | Auckland Rescue`}
        url={router.asPath}
        description={`Buy ${title} online and choose WHERE you want it, WHEN you want it, at the PRICE you want it! It's shopping- but Better!`}
        keywords={`Shop ${title} online`}
      />
      {data.listLoadProduct &&
        (data.isModalShow ? (
          <AgeValidatorModal
            callback={() => {
              if (data.showRegisterPop)
                setIdb((val) => ({ ...val, showRegisterPop: true }));
              setData((preState) => ({
                ...preState,
                isModalShow: false,
                showRegisterPop: false,
              }));
            }}
          />
        ) : (
          <Listing
            styles={styles}
            filters={filters}
            brandName={title}
            brand={brand}
            category={category}
          />
        ))}
    </div>
  );
}

export async function getServerSideProps(ctx) {
  ctx.res.setHeader(
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  );

  const catSlug = ctx?.query?.category || ctx?.params?.slug[1] || null;
  const props = {
    banners: {},
    landscapeBanner: {},
    is18Plus: false,
    brand: {},
  };
  const data = await api(
    {
      url: `/retailer/brand/${ctx.query.slug[0]}`,
      method: "POST",
      data: { slug: ctx.query.slug[0], category: catSlug },
    },
    ctx
  );

  console.log(catSlug, "ll");

  if (catSlug) {
    for (let i = data.category.length; i > 0; i--) {
      let banner = data.category[i - 1].categoryBanner;
      if (
        !Object.keys(props.banners).length &&
        banner &&
        ((banner.banner1 && banner.banner1.imageUrl) ||
          (banner.banner2 && banner.banner2.imageUrl) ||
          (banner.banner3 && banner.banner3.imageUrl))
      ) {
        props.banners = banner;
      }
      let landScapeBanner = data.category[i - 1].landScapeBanner;
      if (
        !Object.keys(props.landscapeBanner).length &&
        landScapeBanner &&
        landScapeBanner &&
        landScapeBanner.imageUrl
      ) {
        props.landscapeBanner = landScapeBanner;
      }
      let alcoholCat = data.category[i - 1].is_18Plus;
      if (alcoholCat && alcoholCat === true) {
        props.is18Plus = true;
      }
    }
  }

  props.brand = data.brand;

  return {
    props,
  };
}

ProductList.Layout = true;

export default ProductList;
